export const userExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{ label: 'First Name', key: 'firstName' },
	{ label: 'Last Name', key: 'lastName' },
	{ label: 'Mobile', key: 'mobile' },
	{ label: 'Email', key: 'email' },
	{
		label: 'Community',
		render: (u) => u?.joinedHub?.name || '',
	},
	{
		label: 'Premium',
		render: (u) => (u?.premium ? 'Yes' : 'No'),
	},
	{
		label: 'Blocked',
		render: (u) => (u?.isUserBlocked ? 'Yes' : 'No'),
	},
	{
		label: 'Joined Date',
		render: (u) => (u?.createdAt ? new Date(u.createdAt).toLocaleDateString() : ''),
	},
]
